import type { AccentToStringMap } from './types';

export const interpolateMessage = (
  template: AccentToStringMap | undefined,
  accent: string,
  interpolations: Record<string, string | number>
): string => {
  const str = template?.[accent] || template?.['en-US'] || '';
  return str.replace(/\{(\w+)\}/g, (_, key: string) => {
    if (interpolations[key] === undefined) {
      return `{${key}}`;
    }
    return String(interpolations[key]);
  });
};

export const shuffleMessages = <T>(items: T[]): T[] =>
  [...items]
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
